import formGroupVod from './formGroupVod';
import formGroupVoDGeneralSettings from './formGroupVoDGeneralSettings';
import formGroupVoDOptimizationSettings from './formGroupVoDOptimizationSettings';
import formGroupVoDEncodingSettings from './formGroupVoDEncodingSettings';
import { storeStructure } from '../store/reducers';
import formGroupOutput from './formGroupOutput';
import formGroupProxyConfig from './formGroupProxyConfig';
import routes from '../routes/route';

export default {
  title: 'VoD Creation',
  attributeName: storeStructure.VoD,
  createURL: 'vod',
  sessionParams: [],
  getURL: 'vod',
  updateURL: 'vod',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  redirectUrl: routes.VOD.path,
  formConfig: [
    formGroupVoDGeneralSettings,
    formGroupOutput,
    formGroupVod,
    formGroupVoDEncodingSettings,
    formGroupVoDOptimizationSettings,

  ],
};
